import CryptoJS from "crypto-js";

// export function generateSEKAndHash(token: any) {
//   const iv = "12345678901234567890123456789012";
//   try {
//     const key = crypto.lib.WordArray.random(32);
//     let dataPayload = {};
//     if (token === "" || token === null || token === undefined) {
//       dataPayload = {
//         appKey: new Date().toISOString(),
//       };
//     } else {
//       dataPayload = {
//         authorization: `Bearer ${token}`,
//         appKey: new Date().toISOString(),
//       };
//     }
//     const appkey = JSON.stringify(dataPayload);
//     const encrypted = crypto.AES.encrypt(appkey, key, {
//       iv: crypto.enc.Utf8.parse(iv),
//       mode: crypto.mode.CBC,
//     });
//     const encryptedHex = encrypted.ciphertext.toString();
//     const keyHash = key.toString();

//     return {
//       hash: keyHash,
//       sek: encryptedHex,
//     };
//   } catch (error) {
//     console.error("", error);
//     return null;
//   }
// }

// export function generateEncryptedKeyBody(body: any) {
//   const iv = "12345678901234567890123456789012";
//   try {
//     const key = crypto.lib.WordArray.random(32);
//     const dataPayload = JSON.stringify(body);

//     const encrypted = crypto.AES.encrypt(dataPayload, key, {
//       iv: crypto.enc.Utf8.parse(iv),
//       mode: crypto.mode.CBC,
//     });
//     const encryptedHex = encrypted.ciphertext.toString();
//     const keyHash = key.toString();

//     return {
//       hash: keyHash,
//       sek: encryptedHex,
//     };
//   } catch (error) {
//     console.error("", error);
//     return null;
//   }
// }



const AES_SECRET = "12345678901234567890123456789012"; // 32 chars = 256-bit key
const AES_IV_Key = "1234567890123456"; // 16 chars = 128-bit IV

export const encryptAES = async (plainText: string): Promise<string> => {
  if (!plainText) throw new Error("encryptAES: plainText is null or empty");


  const key = CryptoJS.enc.Utf8.parse(AES_SECRET);
  const iv = CryptoJS.enc.Utf8.parse(AES_IV_Key);

  const encrypted = CryptoJS.AES.encrypt(plainText, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });


  return encrypted.toString(); // Base64 ciphertext
};




